var map = {
	"./b.png": 8788,
	"./bauddhikgeeks-transparent.png": 6515,
	"./bauddhikgeeks.png": 8856,
	"./buld.jpg": 4152,
	"./cwoc.png": 192,
	"./efi.png": 8188,
	"./flutter.png": 2157,
	"./gdg.png": 5336,
	"./github.png": 2712,
	"./googleAssistant.jpg": 8388,
	"./google_logo.png": 6976,
	"./gtu.png": 1421,
	"./hackathon1.svg": 7236,
	"./iit.png": 6888,
	"./ino.png": 1656,
	"./localguide.gif": 5854,
	"./localguide.png": 6244,
	"./mlh-logo.png": 2944,
	"./mlh-logo.svg": 792,
	"./mlh.png": 9020,
	"./mongo.png": 7200,
	"./nightowls.jpg": 132,
	"./postman.jpg": 4132,
	"./postman.png": 3484,
	"./skillenza.png": 5488,
	"./ssec.png": 8744,
	"./ssgandhy.png": 4312,
	"./valora.jpg": 1200,
	"./wrighter.jpg": 3148,
	"./yinhu.jpg": 2644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3832;